import { useEffect } from 'react';
import { useMapEvents } from 'react-leaflet';

const DynamicMarkerSize = ({ setMarkerSize }) => {
  const map = useMapEvents({
    zoomend: () => {
      const newZoom = map.getZoom();
      const size = newZoom > 10 ? 15 : newZoom > 8 ? 10 : 7; // Adjust sizes dynamically
      setMarkerSize(size);
    },
  });

  useEffect(() => {
    setMarkerSize(map.getZoom() > 10 ? 15 : map.getZoom() > 8 ? 10 : 7);
  }, [map, setMarkerSize]);

  return null; // This component does not render anything
};

export default DynamicMarkerSize;
